import { OperationSupportApi } from "@/api/OperationSupportApi";
import { OperationSupportLog } from "@/types/OperationSupport";

export class OperationSupportService {

  /**
   * 任意のログをDBに記録します
   */
  public async saveLog(logData: OperationSupportLog) {
    const api = new OperationSupportApi();
    try {
      const res = await api.saveLog(logData);
      return res
    } catch (e: any) {
      throw e
    }
  }

}
